import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "src/@/components/ui/table"

import { useState } from "react";
import Iconify from "src/components/Iconify";
import { Button } from "src/@/components/ui/button";
import { Badge } from "src/@/components/ui/badge";

export default function TableScoring({ data, onEdit, onDelete }) {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Nome</TableHead>
          <TableHead>Tipo</TableHead>
          <TableHead>Pontos</TableHead>
          <TableHead>Status</TableHead>
          <TableHead className="w-[100px]"></TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {data.map((row, index) => (
          <TableRow key={index}>
            <TableCell className="font-medium">{row.name}</TableCell>
            <TableCell>
              <Badge
                variant="outline"
                className={
                  row.type === "credit"
                    ? "text-xs font-medium bg-green-50 text-green-700 border-green-200"
                    : "text-xs font-medium bg-red-50 text-red-700 border-red-200"
                }
              >
                {row.type === "credit" ? "Crédito" : "Débito"}
              </Badge>
            </TableCell>
            <TableCell>{row.points}</TableCell>
            <TableCell>
              <Badge
                variant="outline"
                className={
                  row.status === "true"
                    ? "text-xs font-medium bg-green-50 text-green-700 border-green-200"
                    : "text-xs font-medium bg-gray-50 text-gray-500 border-gray-200"
                }
              >
                {row.status === "true" ? "Ativo" : "Inativo"}
              </Badge>
            </TableCell>
            <TableCell>
              <div className="flex gap-2">
                <Button onClick={() => onEdit(row)} variant="outline" size="icon">
                  <Iconify icon={"ph:pencil-line"} />
                </Button>
                <Button onClick={() => onDelete(row)} variant="outline" size="icon">
                  <Iconify color="red" icon={"material-symbols-light:delete-outline"} />
                </Button>
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}
